
export const HISTORICALSEARCH_TEST_IDS = {
  NEXT_BUTTON: "historicalSearch_nextButton_testId",
  BACK_BUTTON: "historicalSearch_backButton_testId",
  WHAT_SECTION: "historicalSearch_whatSection_testId",
  WHERE_SECTION: "historicalSearch_whereSection_testId",
  WHEN_SECTION: "historicalSearch_whenSection_testId",
  RESULT_TABLETS_TAB_DIV: "historicalSearch_resultTablets_tabDiv_testId",
  RETRY_RECENT_SEARCHES_BUTTON: "historicalSearch_retryRecentSearches_testId",
  DELETE_SEARCH_BUTTON: "historicalSearch_deleteSearchButton_testId",
  DELETE_SEARCH_SPINNER: "historicalSearch_deleteSearchSpinner_testId"
};


export const HISTORICALSEARCH_STATICS = {
  NO_SEARCHLICENSE_MESSAGE:
    "Add the ability to search historical video footage for people and vehicles of interest. Contact sales to learn more.",
  SEARCHRESULT_WAITING_MESSAGE:
    "Feel free to leave this page while we perform your search.",
  SEARCHRESULT_WAITING_TITLE: "This may take a while",
  SEARCH_RESULT_WITH_NO_RESPONSE:
    "It looks like there are no results for your current search.<br/>How about <u>modifying your search</u>?",
  NO_RESULTS_FOUND_TITLE: "No Results Found",
  NO_FLOORS_FOR_NONSELECTED_SITES_MESSAGE:
    "You must first select a site in order to select a floor.",
  NO_AREAS_FOR_NONSELECTED_FLOORS_MESSAGE:
    "You must first select a floor in order to select an area."
};

export const SEARCH_SECTIONS = {
  WHAT: "What",
  WHERE: "Where",
  WHEN: "When"
};

export const SEARCH_BUTTON_TEXT = {
  BACK: "Back",
  NEXT: "Next",
  SEARCH: "Search"
};

export const SEARCH_PAGE_TEXT = {
  TITLE: "Search",
  INFO_TEXT: "Search video for people, vehicles, or objects with location and time span.",
  INFO_TEXT_LINE2: "Only stream with a search license are searchable.",
  RECENT_SEARCHES: "My recent searches",
  RECENT_SEARCHES_INFO: "Showing your 10 most recent searches",
  NO_RECENT_SEARCHES: "You don't have any recent searches yet.",
  FETCHING_RECENT_SEARCHES: "Fetching your recent searches...",
  FETCH_RECENT_SEARCHES_ERROR: "Failed to load recent searches",
  RESULTS: "results"
};


export const TYPE_OPTIONS = [
  { label: "Person", value: "person" },
  { label: "Vehicle", value: "vehicle" }
];


export const GENDER_OPTIONS = [
  { label: "Female", value: "female" },
  { label: "Male", value: "male" }
];


export const AGE_OPTIONS = [
  { label: "Young", value: "young" },
  { label: "Adult", value: "adult" },
  { label: "Elderly", value: "elderly" },
  { label: "Child", value: "child" }
];


export const VEHICLE_OPTIONS = [
  { label: "Car", value: "car" },
  { label: "Truck", value: "truck" },
  { label: "Bus", value: "bus" }
];


export const RANDOM_COLORS = [
  { name: "White", hex: "#FFFFFF" },
  { name: "Black", hex: "#000000" },
  { name: "Gray", hex: "#929292" },
  { name: "Green", hex: "#00FF00" },
  { name: "Blue", hex: "#0000FF" },
  { name: "Purple", hex: "#7F007F" },
  { name: "Magenta", hex: "#FF00FF" },
  { name: "Brown", hex: "#7F4000" },
  { name: "Red", hex: "#FF0000" },
  { name: "Orange", hex: "#FF7F00" },
  { name: "Yellow", hex: "#FFFF00" }
];

export const FORENSIC_SEARCH_STATUS_LIST = ["searching",
  "reset",
  "fail",
  "done"];


  export const FORENSIC_SEARCH_DATEFORMAT_MONTHDATE = "MMM DD, YYYY hh:mm A";

  export const SEARCH_STATUS_PAYLOAD = {"statusList": ["searching", "fail","SEARCH_COMPLETED", "uploading", "uploaded", "done"]};

  export const SEARCH_STATUS_PAYLOAD_SEARCH_COMPLETED = "SEARCH_COMPLETED";
  export const SEARCH_STATUS_PAYLOAD_SEARCHING = "searching";
  export const SEARCH_STATUS_PAYLOAD_DONE = "done";
  export const SEARCH_STATUS_PAYLOAD_UPLOADING = "uploading";
  export const SEARCH_STATUS_PAYLOAD_UPLOADED = "uploaded";


  export const FOV_IMAGE = "fovImage";
  export const ENTITY_IMAGE = "fovEntry";
  export const FORENSIC_IMAGE_DOWNLOAD_IDENTIFIER = "forensics";
  export const SNAPSHOT_IMAGE_DOWNLOAD_IDENTIFIER = "snapshot";

  export const FORENSIC_SEARCH_SAGA_STATUS_FAILED = "Failed";

  export const FORENSIC_SEARCH_SAGA_MESSAGES = {
    SEARCH_DELETE_SUCCESS: "Search deleted successfully.",
    SEARCH_DELETE_FAILED: "Search deletion failed",
    SEARCH_DELETE_FAILED_STATUSTEXT: "Search deletion failed.",
    IMAGE_INDEX_FETCH_SUCCESS: "Image index fetch succeeded.",
    IMAGE_INDEX_FETCH_FAILED: "Image index fetch failed",
    IMAGE_INDEX_FETCH_FAILED_STATUSTEXT: "Image index fetch failed."
  };

  export const NO_IMAGE_PLACEHOLDER = "NoImage";

  export const LAZY_IMAGE_MESSAGES = {
    FETCHING_SNAPSHOT: "Fetching snapshot from device...",
    FETCH_FAILED: "Failed to fetch snapshot",
    SNAPSHOT_NOT_AVAILABLE: "Snapshot not available"
  };
